import React, { useEffect } from "react";
import { Breadcrumb, Button, Input, InputPicker, Loader, Table } from "rsuite";
import DocumentTitle from "../../Components/DocumentTitle";
import PageContainer from "../../Components/PageContainer/PageContainer";
import { frontDB } from "../../frontDB";
import styles from "./Documents.module.css";
import { useDocuments } from "./useDocuments";
import BreadCrumb from "./Components/BreadCrumb/BreadCrumb";
import { MdOutlineCreateNewFolder } from "react-icons/md";
import Item from "./Components/Item/Item";
import { RiArrowGoBackFill } from "react-icons/ri";
import { IoReload } from "react-icons/io5";
import FileUploaderModal from "./Components/FileUploaderModal/FileUploaderModal";
import { useFileUploaderModal } from "./Components/FileUploaderModal/useFileUploaderModal";

function Documents() {
  DocumentTitle("RitePMS Office - Document Management");
  let { locations, location } = frontDB();

  let locationOptions = [
    ...locations
      .filter((location) => location.name != "Office")
      .map((item) => ({ label: item.name, value: item._id })),
  ];

  let {
    currentNode,
    locationId,
    locationHandler,
    handleCreateFolder,
    initialize,
    handleRename,
    navigateToPath,
    loading,
    openFolder,
    setLocationId,
  } = useDocuments();

  let { showFileUploaderModal } = useFileUploaderModal();

  useEffect(() => {
    if (location) {
      setLocationId(location._id);
    } else {
      setLocationId(locationOptions[0].value);
    }
  }, []);
  useEffect(() => {
    if (locationId) {
      initialize();
    }
  }, [locationId, initialize, location]);

  let allItems =
    currentNode && currentNode.children && currentNode.children.length > 0
      ? [...currentNode.children].sort((a, b) => {
          // First, sort by whether fileId is null
          if (a.fileId === null && b.fileId !== null) return -1;
          if (a.fileId !== null && b.fileId === null) return 1;
          // If both have null or non-null fileId, sort by name
          return a.name.localeCompare(b.name);
        })
      : null;

  let allParts_section = (
    <>
      <div className={styles.header}>
        <div className={styles.header_title}>Document Management</div>
      </div>
      {locationId && (
        <>
          <div className={styles.files_taskbar}>
            <div className={styles.buttons_taskbar}>
              <Button
                disabled={!currentNode || !currentNode.parent}
                onClick={() => {
                  if (currentNode && currentNode.parent) {
                    navigateToPath(currentNode.parent);
                  }
                }}
              >
                <RiArrowGoBackFill />
              </Button>
              <Button
                onClick={() => {
                  openFolder(currentNode, true);
                }}
              >
                <IoReload />
              </Button>

              <InputPicker
                value={locationId}
                onChange={locationHandler}
                cleanable={false}
                placeholder="Select"
                data={locationOptions}
                style={{ width: 180 }}
              />
              <BreadCrumb />
            </div>
            <Button onClick={handleCreateFolder} className={styles.button}>
              <MdOutlineCreateNewFolder style={{ marginRight: 5 }} /> Create
              Folder
            </Button>
          </div>
          {loading ? (
            <div className={styles.loader_container}>
              <Loader size="lg" content="Loading..." />
            </div>
          ) : (
            <div className={styles.files_container}>
              {currentNode &&
                allItems &&
                allItems.map((item) => (
                  <Item
                    key={item.id}
                    item={item}
                    handleRename={handleRename}
                    onOpenFolder={openFolder}
                  />
                ))}
            </div>
            // <div className={styles.files_container}>
            // 	{currentNode &&
            // 		currentNode.children.map((item) => (
            // 			<Item key={item.id} item={item} handleRename={handleRename} onOpenFolder={openFolder} />
            // 		))}
            // </div>
          )}
          {currentNode && currentNode.id != "root" && (
            <Button
              color="blue"
              onClick={showFileUploaderModal}
              appearance="primary"
              style={{ width: 200 }}
            >
              Add files
            </Button>
          )}
          <FileUploaderModal locationId={locationId} />
        </>
      )}
    </>
  );

  return (
    <PageContainer>
      <>{allParts_section}</>
    </PageContainer>
  );
}

export default Documents;
